export default __webpack_public_path__ + "static/media/Linked List Visual.1ada8853.svg";